export default () => {
  return {
    title: 'glacier',
    artist: '-',
    src: 'glacier',
    pic: 'glacier',
    _id: '',
    num: 0
  }
}
